export function cloneDeep(value) {
  if (Array.isArray(value)) {
    return value.map(function (item) {
      return cloneDeep(item);
    });
  }

  if (value !== null && typeof value === 'object') {
    var nextValue = {};

    for (var key in value) {
      if (value.hasOwnProperty(key)) {
        nextValue[key] = cloneDeep(value[key]);
      }
    }

    return nextValue;
  }

  return value;
}